import { SpecData } from 'src/models';

export const checkCustUpdateEmail = (apptDepartment: string | undefined, specData: SpecData | undefined) => {
    if (apptDepartment) {
        switch (apptDepartment) {
            case ('Q'):
                return specData?.ossSpecs?.custUpdateEml === 'Y';
            case ('B'):
                return specData?.bdySpecs?.custUpdateEml === 'Y';
            case ('S'):
                return specData?.svcSpecs?.custUpdateEml === 'Y';
            default:
                return false;
        }
    } else {
        if (specData?.svcSpecs) {
            return specData?.svcSpecs?.custUpdateEml === 'Y';
        } else if (specData?.ossSpecs) {
            return specData?.ossSpecs?.custUpdateEml === 'Y';
        } else if (specData?.bdySpecs) {
            return specData?.bdySpecs?.custUpdateEml === 'Y';
        }

        return false;
    }
};